import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './ContentPagePreview.css';

import PagePreview from '../../components/PagePreview/PagePreview';

class ContentPagePreview extends React.Component {
    static propTypes = {
         data: PropTypes.any
    }

    render() {
        const {  data } =  this.props;
        let title = data.getContentPage.metaTitle;
        return (
            <div>
                <PagePreview title={title} data={data}/>
            </div>
        )
    }
}

export default withStyles(s)(ContentPagePreview);